interface ResizeConfig {
  width: number;
  height: number;
  mode?: string;
  type?: string; //文件类型
  onFail: Function;
  onSuccess: Function;
}

export default (file: File, config: ResizeConfig) => {
  const reader = new FileReader();

  return new Promise((resolve, reject) => {
    reader.onload = function (evt: Event) {
      const result = (evt.target as FileReader)?.result;
      if (!result) {
        resolve({
          success: false,
        });
      } else {
        const imageDom = new Image();
        imageDom.onload = function () {
          let width = imageDom.width;
          let height = imageDom.height;
          let willResize = false;
          let sx: number = 0,
            sy: number = 0,
            sWidth: number = 0,
            sHeight: number = 0;

          //尺寸判断
          if (config.mode === 'fill') {
            if (
              (width > config.width && height >= config.height) ||
              (width >= config.width && height > config.height)
            ) {
              if (width / config.width > height / config.height) {
                width = Math.floor((width * config.height) / height);
                height = config.height;

                sx = Math.floor(
                  (imageDom.width -
                    (config.width * imageDom.height) / config.height) /
                    2,
                );
                sy = 0;
                sWidth = imageDom.width - sx * 2;
                sHeight = imageDom.height;
              } else {
                height = Math.floor((height * config.width) / width);
                width = config.width;

                sx = 0;
                sy = Math.floor(
                  (imageDom.height -
                    (config.height * imageDom.width) / config.width) /
                    2,
                );
                sWidth = imageDom.width;
                sHeight = imageDom.height - sy * 2;
              }
              willResize = true;
            }
          } else {
            if (width > config.width) {
              height = Math.floor((height * config.width) / width);
              width = config.width;
              willResize = true;
            }
            if (height > config.height) {
              width = Math.floor((width * config.height) / height);
              height = config.height;
              willResize = true;
            }
            sx = 0;
            sy = 0;
            sWidth = imageDom.width;
            sHeight = imageDom.height;
          }
          if (willResize) {
            const canvas = document.createElement('canvas');
            if (config.mode === 'fill') {
              canvas.width = config.width;
              canvas.height = config.height;
            } else {
              canvas.width = width;
              canvas.height = height;
            }
            const ctx = canvas.getContext('2d');
            if (ctx) {
              ctx.drawImage(
                imageDom,
                sx,
                sy,
                sWidth,
                sHeight,
                0,
                0,
                canvas.width,
                canvas.height,
              );
              resolve({
                success: false,
                content: canvas.toDataURL(config.type, 0.95),
              });
            } else {
              resolve({ success: false });
            }
          } else {
            resolve({ success: true });
          }
        };
        imageDom.src = result.toString();
      }
    };
    reader.readAsDataURL(file);
  }).then((res: any) => {
    if (res.content) {
      let [mimeStr, bstr] = res.content.split(',');
      let mime = mimeStr.match(/:(.\*?);/)?.[1];
      let b = atob(bstr);
      let n = b.length;
      let u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = b.charCodeAt(n);
      }
      let rImage = new File([u8arr], file.name, { type: file.type });
      config.onSuccess(rImage);
      return rImage;
    }
    if (!res.success) {
      config.onFail();
      return false;
    }
    config.onSuccess();
    return true;
  });
};
